import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { authService } from '../../services/authService';

const Header = () => {
  const { user } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await authService?.signOut();
      window.location.href = '/home-landing';
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/home-landing" className="flex items-center gap-3">
            <img 
              src="/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg" 
              alt="Edrian Bass" 
              className="w-10 h-10 rounded-full object-cover"
            />
            <span className="text-xl font-bold text-foreground">Edrian Bass</span>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/home-landing" className="text-foreground hover:text-primary transition-colors">
              Home
            </Link>
            <Link to="/about-me" className="text-foreground hover:text-primary transition-colors">
              About
            </Link>
            <Link to="/services-portfolio" className="text-foreground hover:text-primary transition-colors">
              Services
            </Link>
            <Link to="/project-portfolio" className="text-foreground hover:text-primary transition-colors">
              Projects
            </Link>
            <Link to="/blog-insights" className="text-foreground hover:text-primary transition-colors">
              Blog
            </Link>
            <Link to="/contact-hub" className="text-foreground hover:text-primary transition-colors">
              Contact
            </Link>
            {user ? (
              <button
                onClick={handleSignOut}
                className="px-4 py-2 bg-error text-white rounded-lg hover:opacity-90 transition-opacity"
              >
                Sign Out
              </button>
            ) : (
              <Link
                to="/signin"
                className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
              >
                Admin Login
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 text-foreground hover:text-primary transition-colors"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Panel */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background border-b border-border">
          <nav className="flex flex-col px-4 py-4 space-y-4">
            <Link
              to="/home-landing"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              Home
            </Link>
            <Link
              to="/about-me"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              About
            </Link>
            <Link
              to="/services-portfolio"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              Services
            </Link>
            <Link
              to="/project-portfolio"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              Projects
            </Link>
            <Link
              to="/blog-insights"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              Blog
            </Link>
            <Link
              to="/contact-hub"
              onClick={closeMobileMenu}
              className="text-foreground hover:text-primary transition-colors py-2"
            >
              Contact
            </Link>
            {user ? (
              <button
                onClick={() => {
                  closeMobileMenu();
                  handleSignOut();
                }}
                className="px-4 py-2 bg-error text-white rounded-lg hover:opacity-90 transition-opacity text-left"
              >
                Sign Out
              </button>
            ) : (
              <Link
                to="/signin"
                onClick={closeMobileMenu}
                className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity text-center"
              >
                Admin Login
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;